const baseURL = 'https://inversionesnb.soluditec.com/';

export default baseURL;
